<template>
  <article>
    <b-row>
      <LmTextInput
        class="col-4"
        :placeholder="$t('name')"
        :label="$t('name')"
        :v="$v.value.name"
        v-model="value.name"
      />
      <!-- NOTA
        v-if="dataOriginOptions.length"
        Fix para problema de asincronismo en modo edición.
        Me aseguro de cargar las opciones antes del v-model
       -->
      <LmSuperPowerSelectV2
        v-if="dataOriginOptions.length"
        class="col-4"
        :placeholder="$t('data_origin')"
        :label="$t('data_origin')"
        :v="$v.value.dataOrigin"
        v-model="value.dataOrigin"
        :options="dataOriginOptions"
      />
      <LmCheckbox
        class="col-12"
        :title="$t('avaible_sizes')"
        type="multiple"
        :options="sizesOptions"
        v-model="value.sizes"
      />
    </b-row>
  </article>
</template>

<script>
// Utils
import { required } from 'vuelidate/lib/validators'
import commonsApi from '@/api/commons'

// Components
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmCheckbox from '@/components/form/elements/LmCheckbox'
import LmSuperPowerSelectV2 from '@/components/form/elements/LmSuperPowerSelectV2'

export default {
  components: {
    LmTextInput,
    LmCheckbox,
    LmSuperPowerSelectV2
  },
  props: {
    value: Object,
    isOnEditMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dataOriginOptions: [],
      sizesOptions: [
        {
          text: '25%',
          value: 3
        },
        {
          text: '50%',
          value: 6
        },
        {
          text: '75%',
          value: 9
        },
        {
          text: '100%',
          value: 12
        }
      ]
    }
  },
  validations: {
    value: {
      name: {
        required
      },
      dataOrigin: {
        required
      }
    }
  },
  async created () {
    try {
      const lists = await commonsApi.axiosGetWrapper('/listbuilder/all')
      this.dataOriginOptions = lists.data.items
    } catch (error) {
      console.log(error)
    }
  }
}
</script>

<style>

</style>
